// 9fbef606107a605d69c0edbcd8029e5d
import styled from 'styled-components';

export default styled.div`
  .contact_information_form {
    > label {
      > p {
        margin-top: ${(props) => (props.spc ? '0' : props.theme.spacing.ELEM_SPACING.XXS)};
      }
    }
  }

  .click-here-link {
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    font-weight: ${(props) => props.theme.typography.fontWeights.regular};
    text-underline-position: under;
    text-decoration: underline;
  }
  .benefit_heading{
      font-family: ${(props) => props.theme.typography.fonts.secondary};
      font-size: ${(props) => props.theme.typography.fontSizes.fs16};
      font-weight: ${(props) => props.theme.fonts.fontWeight.bold};
      margin: 34px 0px 0px 0px;
      line-height: 1;
      padding-bottom: ${(props) => (props.spc ? props.theme.spacing.ELEM_SPACING.LRG : '')};
      text-align: left;
  }
  .benefit_description1,.benefit_description2,.benefit_description3{
    font-family: ${(props) => props.theme.typography.fonts.secondary};
    font-weight: ${(props) => props.theme.typography.fontWeights.regular};
    font-size: ${(props) => props.theme.typography.fontSizes.fs16};
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }
  .benefit_description3{
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.XL}
  }
  .benefit-here-link”{
    text-decoration: none;
    text-decoration: underline;
    color: ${(props) => props.theme.colorPalette.gray['900']};

  }
`;
